import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Login from './views/Login'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'main',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "main" */ './views/main'),
      children: [
        {
          path: '/',
          name: 'welfarelist',
          component: () => import(/* webpackChunkName: "list" */ './views/main/WelfareList.vue')
        },
        {
          path: 'mates',
          name: 'mates',
          component: () => import(/* webpackChunkName: "mate" */ './views/main/Mates.vue')
        },
        {
          path: 'welfarelist',
          name: 'welfarelist',
          component: () => import(/* webpackChunkName: "list" */ './views/main/WelfareList.vue')
        },
        {
          path: '/welfare',
          name: 'welfare',
          component: () => import(/* webpackChunkName: "welfare" */ './views/main/Welfare.vue')
        },
        {
          path: '/welfarereset',
          name: 'welfarereset',
          component: () => import(/* webpackChunkName: "welfarereset" */ './views/main/WelfareReset.vue')
        },
        {
          path: '/bill',
          name: 'bill',
          component: () => import(/* webpackChunkName: "bill" */ './views/main/Bill.vue')
        },
        {
          path: '/detail',
          name: 'detail',
          component: () => import(/* webpackChunkName: "detail" */ './views/main/WelfareDetail.vue')
        },
        {
          path: '/customer',
          name: 'customer',
          component: () => import(/* webpackChunkName: "customer" */ './views/main/customer.vue')
        },
        {
          path: '/department',
          name: 'department',
          component: () => import(/* webpackChunkName: "department" */ './views/main/department.vue')
        },
        {
          path: '/topUp',
          name: 'topUp',
          component: () => import(/* webpackChunkName: "topUp" */ './views/main/topUp.vue')
        },
        {
          path: '/OffPeakDining',
          name: 'OffPeakDining',
          component: () => import(/* webpackChunkName: "topUp" */ './views/OffPeakDining.vue')
        }
      ]
    }
  ]
})
